import React, { useState } from "react";
import Icon from "../../images/logo192.png";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  console.log(open);
  return (
    <div className="max-w-screen overflow-x-hidden font-poppins">
      <nav className="bg-gradient-to-r from-green-900 to-blue-900 fixed px-2 sm:h-auto sm:w-full w-screen z-20 left-0 right-0 top-0 border-b border-gray-400 shadow-lg">
        {/* desktop nav */}
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto sm:p-4 pb-2">
          <Link to="/" className="flex items-center">
            <img
              src={Icon}
              alt="icon"
              className="hidden sm:block sm:w-[35px] sm:h-[35px] "
            />
            <span className="ml-2 mt-2 sm:mt-0 text-white font-semibold text-xl">
              ETS Rose
            </span>
          </Link>
          <div className="flex items-center gap-4">
            <ul className="sm:flex justify-center hidden">
              <li className="p-2 mr-4 text-white hover:text-yellow-400 cursor-pointer transition-colors duration-200">
                <Link to="/">ACCUEIL</Link>
              </li>
              <li className="p-2 mr-4 text-white hover:text-yellow-400 cursor-pointer transition-colors duration-200">
                <Link to="/about">QUI NOUS-SOMMES</Link>
              </li>
              <li className="p-2 mr-4 text-white hover:text-yellow-400 cursor-pointer transition-colors duration-200">
                <Link to="/services">PRODUITS ET SERVICES</Link>
              </li>
              <li className="p-2 text-white hover:text-yellow-400 cursor-pointer transition-colors duration-200">
                <Link to="/contact">CONTACT</Link>
              </li>
            </ul>
            <button 
              onClick={() => setOpen(!open)} 
              className="sm:hidden text-white focus:outline-none"
            >
              <GiHamburgerMenu size={24} />
            </button>
          </div>
        </div>

        {/* desktop nav end */}
        {/* Updated mobile nav */}
        <div className={`${open ? "block" : "hidden"} transition-all duration-300 ease-in-out bg-gradient-to-r from-green-900 to-blue-900 shadow-lg`}>
          <ul className="pt-4 pb-4">
            <li className="text-white hover:text-yellow-300 font-medium pl-8 py-3 transition-colors duration-200">
              <Link to="/">ACCUEIL</Link>
            </li>
            <li className="text-white hover:text-yellow-300 font-medium pl-8 py-3 transition-colors duration-200">
              <Link to="/about">QUI NOUS-SOMMES</Link>
            </li>
            <li className="text-white hover:text-yellow-300 font-medium pl-8 py-3 transition-colors duration-200">
              <Link to="/services">PRODUITS ET SERVICES</Link>
            </li>
            <li className="text-white hover:text-yellow-300 font-medium pl-8 py-3 transition-colors duration-200">
              <Link to="/contact">CONTACT</Link>
            </li>
          </ul>
          <div className="flex flex-col items-center pb-4">
            <p className="text-gray-100/80 text-sm">
              © 2025 All Rights Reserved - <button onClick={() => window.open('https://hyphentech.tech', '_blank')} className="underline hover:text-yellow-300 cursor-pointer bg-transparent border-none p-0 text-gray-100/80 text-sm">@Hyphen Tech</button>
            </p>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
